module.exports = __webpack_public_path__ + "d28c443559ebc17ac2785948f49754c7.svg";